module.exports = __webpack_public_path__ + "DINNextLTPro-BoldCondensed.woff2?d9644a2955d1576a2fee638b667e645c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-BoldCondensed.woff2
// module id = 1388
// module chunks = 0